import { wrap } from '@motionone/utils';
import { AnimatePresence } from 'framer-motion';
import uniqueId from 'lodash/uniqueId';
import React, { useState } from 'react';

import { PersonTileCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as A from './BusinessCardCarousel.animations';

import * as S from './BusinessCardCarousel.styles';

export interface BusinessCardCarouselProps {
  people: PersonTileCMS[];
  id: number;
  linkedInLabel: string;
  heading: string;
}

export interface BusinessCardProps extends PersonTileCMS {
  toPrevious?: boolean;
  linkedInLabel: string;
  heading: string;
}
const BusinessCard: React.FunctionComponent<BusinessCardProps> = ({
  image,
  // overlay,
  title,
  description,
  linkedInURL,
  linkedInLabel,
  heading,
}) => (
  <S.PersonWrapper
    variants={A.businessCardVariant}
    key={title}
    initial="initial"
    animate="enter"
    exit="exit"
  >
    <S.PersonHeading>{heading}</S.PersonHeading>
    <S.Heading>{title}</S.Heading>
    <S.ImageWrapper>
      <S.ProfilePicture src={image.url} alt={image.alternativeText} />
    </S.ImageWrapper>
    <S.Description richText={description} defaultSpacing />
    <S.Anchor href={linkedInURL} target="_blank">
      {linkedInLabel}
    </S.Anchor>
  </S.PersonWrapper>
);

const BusinessCardCarousel: React.FunctionComponent<
  BusinessCardCarouselProps
> = ({ people, id, linkedInLabel, heading }) => {
  const [person, setPerson] = useState<number>(id);
  const [toPrevious, setToPrevious] = useState(false);

  const changeSlide = (to: -1 | 1) => {
    setPerson(i => wrap(0, people.length, i + to));
    setToPrevious(to < 0);
  };

  const subtitle = (
    <S.SubtitleWrapper>
      <AnimatePresence mode="wait">
        <S.Subtitle
          variants={A.subtitleVariant}
          key={uniqueId(people[person].subtitle)}
          initial="initial"
          animate="enter"
          exit="exit"
        >
          {people[person].subtitle}
        </S.Subtitle>
      </AnimatePresence>
    </S.SubtitleWrapper>
  );

  const carousel = (
    <AnimatePresence>
      <BusinessCard
        {...people[person]}
        key={`business_card_${id}`}
        toPrevious={toPrevious}
        linkedInLabel={linkedInLabel}
        heading={heading}
      />
    </AnimatePresence>
  );
  const navigation = (
    <S.Navigation>
      {subtitle}

      <S.ButtonLeft onClick={() => changeSlide(-1)} />
      <S.ButtonRight onClick={() => changeSlide(1)} />
    </S.Navigation>
  );

  return (
    <S.BusinessCardCarouselWrapper>
      {carousel}

      {navigation}
    </S.BusinessCardCarouselWrapper>
  );
};

export default BusinessCardCarousel;
